import { useTranslation } from "react-i18next";

export const useLocale = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language || "cs-CZ";

  return locale;
};
